// returns the responsive card width for a grid layout
// params:
// - numColumns: number of columns in the grid
// - horizontalPadding: total horizontal padding (in px)
import { mvs } from 'react-native-size-matters';

export function getResponsiveCardWidth({
  width,
  numColumns,
  horizontalPadding,
}: {
  width: number;
  numColumns: number;
  horizontalPadding: number;
}): number {
  const horizontalGap = mvs(12);
  const totalGaps = horizontalGap * (numColumns - 1);
  const availableWidth = width - horizontalPadding * 2;
  const finalWidth = availableWidth - totalGaps;
  return finalWidth / numColumns;
}
